
import { defineComponent } from "vue";

export default defineComponent({
  name: "PrivacyPolicy",
  setup() {
    return {};
  },
});
